/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
export class DatagridRenderOrganizer {
private alreadySized = false;
public widths: {px: number, strict: boolean}[] = [];

    protected _noLayout = new Subject<boolean>();
/**
 * @return {?}
 */
public get noLayout(): Observable<boolean> {
        return this._noLayout.asObservable();
    }

    protected _clearWidths = new Subject<any>();
/**
 * @return {?}
 */
public get clearWidths(): Observable<any> {
        return this._clearWidths.asObservable();
    }

    protected _detectStrictWidths = new Subject<any>();
/**
 * @return {?}
 */
public get detectStrictWidths(): Observable<any> {
        return this._detectStrictWidths.asObservable();
    }

    protected _tableMode = new Subject<boolean>();
/**
 * @return {?}
 */
public get tableMode(): Observable<boolean> {
        return this._tableMode.asObservable();
    }

    protected _computeWidths = new Subject<any>();
/**
 * @return {?}
 */
public get computeWidths(): Observable<any> {
        return this._computeWidths.asObservable();
    }

    protected _alignColumns = new Subject<any>();
/**
 * @return {?}
 */
public get alignColumns(): Observable<any> {
        return this._alignColumns.asObservable();
    }
public scrollbar = new Subject<any>();
public scrollbarWidth = new Subject<number>();

    protected _done = new Subject<any>();
/**
 * @return {?}
 */
public get done(): Observable<any> {
        return this._done.asObservable();
    }
/**
 * @return {?}
 */
public resize() {
        this.widths.length = 0;
        this._noLayout.next(true);
        if (this.alreadySized) {
            this._clearWidths.next();
        }
        this._detectStrictWidths.next();
        this._tableMode.next(true);
        this._computeWidths.next();
        this._tableMode.next(false);
        this._alignColumns.next();
        this._noLayout.next(false);
        this.scrollbar.next();
        this.alreadySized = true;
        this._done.next();
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DatagridRenderOrganizer_tsickle_Closure_declarations() {
/** @type {?} */
DatagridRenderOrganizer.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatagridRenderOrganizer.ctorParameters;
/** @type {?} */
DatagridRenderOrganizer.prototype.alreadySized;
/** @type {?} */
DatagridRenderOrganizer.prototype.widths;
/** @type {?} */
DatagridRenderOrganizer.prototype._noLayout;
/** @type {?} */
DatagridRenderOrganizer.prototype._clearWidths;
/** @type {?} */
DatagridRenderOrganizer.prototype._detectStrictWidths;
/** @type {?} */
DatagridRenderOrganizer.prototype._tableMode;
/** @type {?} */
DatagridRenderOrganizer.prototype._computeWidths;
/** @type {?} */
DatagridRenderOrganizer.prototype._alignColumns;
/** @type {?} */
DatagridRenderOrganizer.prototype.scrollbar;
/** @type {?} */
DatagridRenderOrganizer.prototype.scrollbarWidth;
/** @type {?} */
DatagridRenderOrganizer.prototype._done;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
